import api from './api';

export const getEmailTemplatesApi = (params) => api().get('/email-templates', { params });
export const addNewEmailTemplateApi = (data) => api().post('/email-templates', data);
export const deleteEmailTemplatesApi = (params) => api().delete('/email-templates', { params });
export const updateEmailTemplatesApi = (params) => api().put(`/email-templates/${params.id}`, params.values);
